var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card card-with-shadow border border-0 mb-primary"},[_c('div',{staticClass:"card-body"},[_c('app-form-wizard',{attrs:{"tabs":_vm.tabs},on:{"selectedComponentName":_vm.selectedComponent,"disabledTab":_vm.currentDisableTab}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }